export var StorageCookiesEnum;
(function (StorageCookiesEnum) {
    StorageCookiesEnum["ACCESS_TOKEN"] = "accessToken";
    StorageCookiesEnum["ACCESS_KEY_EXPIRED"] = "accessKeyExpired";
    StorageCookiesEnum["AGENT_TOKEN"] = "agentToken";
    StorageCookiesEnum["AGENT_REFRESH_TOKEN"] = "agentRefreshToken";
    StorageCookiesEnum["USERNAME"] = "username";
    StorageCookiesEnum["REFRESH_TOKEN"] = "refreshToken";
    StorageCookiesEnum["FLAG_USER_EMAIL_NOT_VALIDATED"] = "userWithEmailNotValidated";
    StorageCookiesEnum["SHOW_MODAL_EXPIRATION"] = "showModalExpiration";
    StorageCookiesEnum["ONBOARDING_COMPLETED"] = "onboardingCompleted";
    StorageCookiesEnum["REFRESH_TOKEN_ALIVE"] = "refreshTokenAlive";
    StorageCookiesEnum["FIRST_TIME_LOGIN"] = "firstTimeLogin";
})(StorageCookiesEnum || (StorageCookiesEnum = {}));
//# sourceMappingURL=storage-cookies.enum.js.map